/**
 * @file auth-actions.ts
 * @description Redux Toolkit асинхронные действия для системы аутентификации в Task Manager приложении. Содержит createAsyncThunk действия для регистрации пользователей (registerUser), входа в систему (userLogin) и выхода (userLogout) с полной обработкой HTTP запросов через Axios, управлением JWT токенами, интеграцией с localStorage и централизованной обработкой ошибок API для обеспечения безопасного доступа к защищенным ресурсам приложения.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-15
 * @dependencies ['@api/config', '@reduxjs/toolkit', '@utils/token-helper']
 * @related-files ['src/features/auth/auth-slice.ts', 'src/api/config.ts', 'src/utils/token-helper.ts', 'src/pages/login/login.component.tsx']
 */

import instance from '@api/config';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { setToken } from '@utils/token-helper';

interface ICredentions {
    username: string;
    password: string;
}

export const registerUser = createAsyncThunk(
    'auth/register',
    async ({ username, password }: ICredentions, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };
            await instance().post('register', { username, password }, config);
        } catch (error: any) {
            // return custom error message from backend if present
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message);
            } else {
                return rejectWithValue(error.message);
            }
        }
    }
);

export const userLogin = createAsyncThunk(
    'auth/login',
    async ({ username, password }: ICredentions, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };
            const { data } = await instance().post('account/login', { username, password }, config);

            localStorage.setItem(`${import.meta.env.VITE_BASE_URL}_refreshToken`, data.refreshToken);
            setToken(data.accessToken, data.accessTokenExpiresAt);

            return data;
        } catch (error: any) {
            // return custom error message from API if any
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message);
            } else {
                return rejectWithValue(error.message);
            }
        }
    }
);

export const userLogout = createAsyncThunk('auth/logout', async (_, { rejectWithValue }) => {
    try {
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };
        const refreshToken = localStorage.getItem(`${import.meta.env.VITE_BASE_URL}_refreshToken`);
        const { data } = await instance().post('account/logout', { refreshToken }, config);

        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data.message) {
            return rejectWithValue(error.response.data.message);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
